/* unplugin-vue-components disabled */import script from "./OrderFilterBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderFilterBlock.vue?vue&type=script&setup=true&lang=ts"

import "./OrderFilterBlock.vue?vue&type=style&index=0&id=dc667446&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc667446"]])

export default __exports__